import type { SiteLineSession } from './managed-identity-client';

let current: SiteLineSession | null = null;
const listeners = new Set<() => void>();
const scope = (session: SiteLineSession | null) => session ? JSON.stringify([session.uid, session.principalUid, session.tenantId, session.branchId, session.role, session.orgRole, session.tier, session.csrf,
  session.profile?.email, session.profile?.emailVerified]) : '';
/** In-memory descriptor only. The opaque cookie is never available here. */
export function setManagedTransportSession(session: SiteLineSession | null) {
  const changed = scope(current) !== scope(session);
  current = session;
  if (changed) listeners.forEach(listener => listener());
}
export function requireManagedTransportSession(): SiteLineSession {
  if (!current || current.expiresAt <= Date.now()) throw new Error('SESSION_REQUIRED');
  return current;
}
export function onManagedTransportScopeChange(listener: () => void) {
  listeners.add(listener); return () => { listeners.delete(listener); };
}
